/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeasurementUIDTOV0 } from './measurementUIDTOV0';
import { PropertySummaryUIDTOV0 } from './propertySummaryUIDTOV0';
import { SAPLZCEnergySourceCodeUIDTOV0 } from './sAPLZCEnergySourceCodeUIDTOV0';
import { MoneyUIDTOV0 } from './moneyUIDTOV0';
import { RdSAPSuggestedImprovementUIDTOV0 } from './rdSAPSuggestedImprovementUIDTOV0';


export interface RdSAPResultsDetailUIDTOV0 { 
    /**
     * The current SAP energy rating.
     */
    readonly sapRating?: number;
    /**
     * The potential SAP energy rating.
     */
    readonly potentialSAP?: number;
    /**
     * The current environmental impact rating.
     */
    readonly eiRating?: number;
    /**
     * The potential environmental impact rating.
     */
    readonly potentialEI?: number;
    /**
     * The current co2 emissions value.
     */
    readonly co2EmissionCurrent?: number;
    /**
     * The potential co2 emissions value.
     */
    readonly co2EmissionPotential?: number;
    /**
     * The existing dwelling\'s space heating demand.
     */
    readonly spaceHeatingDemand?: number;
    /**
     * The water heating demand.
     */
    readonly waterHeatingDemand?: number;
    /**
     * The current primary energy consumption value.
     */
    readonly primaryEnergyUseCurrent?: number;
    /**
     * The potential primary energy consumption value.
     */
    readonly primaryEnergyUsePotential?: number;
    /**
     * The heat demand per square meter, calculated by dividing the space heating demand by the total floor area.
     */
    readonly heatDemandPerSquareMeter?: number;
    /**
     * The version of RdSAP used for the report.
     */
    readonly rdsapVersion?: string;
    /**
     * The national unique property reference number.
     */
    readonly nationalUPRN?: string;
    /**
     * Numeric value representing the energy rating, minimum value is 0.
     */
    energyRatingAverage?: number;
    lightingCostCurrent?: MoneyUIDTOV0;
    lightingCostPotential?: MoneyUIDTOV0;
    heatingCostCurrent?: MoneyUIDTOV0;
    heatingCostPotential?: MoneyUIDTOV0;
    hotWaterCostCurrent?: MoneyUIDTOV0;
    hotWaterCostPotential?: MoneyUIDTOV0;
    c02EmissionsCurrentPerFloorArea?: MeasurementUIDTOV0;
    /**
     * Low and zero carbon energy source(s) for the property. 
     */
    readonly lzcEnergySources?: Array<SAPLZCEnergySourceCodeUIDTOV0>;
    propertySummary?: PropertySummaryUIDTOV0;
    readonly recommendations?: Array<RdSAPSuggestedImprovementUIDTOV0>;
    /**
     * Alternative improvements (alternativeRecommendations) to some of those given in Suggested Improvements (recommendations).
     */
    readonly alternativeRecommendations?: Array<RdSAPSuggestedImprovementUIDTOV0>;
}

